// src/App.js
import React, { useEffect, useState } from "react";
import Navbar, {NavbarSimple} from "./components/Navbar/Navbar";
import Contexto from "./components/Contexto/Contexto";
import "./styles/App.css";
import UsoSuelo from "./components/UsoSuelo/UsoSuelo";
import Escenarios from "./components/Escenarios/Escenarios";
import EmisionesCarbono from "./components/EmisionesCarbono/EmisionesCarbono";

export function useIsNotPhone() {
  const detect = () => {
    if (typeof navigator === "undefined") return true; // Assume non-phone in SSR

    // Newer browsers (more reliable)
    if (navigator.userAgentData && Array.isArray(navigator.userAgentData.brands)) {
      const mobileFlag = navigator.userAgentData.mobile; // true if mobile phone or tablet
      return !mobileFlag; // true if NOT mobile
    }

    // Fallback: regex on UA string
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isPhone = /Mobi|Android.+Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    return !isPhone;
  };

  const [isNotPhone, setIsNotPhone] = React.useState(detect);

  React.useEffect(() => {
    setIsNotPhone(detect());
  }, []);

  return isNotPhone;
}

function NotAvailableScreen() {
  return (
     <div className="h-screen w-screen flex flex-col bg-gradient-to-b from-[#324130] to-[#92843B] text-white">
      <NavbarSimple />
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-md text-center space-y-4">
        <h1 className="text-2xl font-bold">Content Available only on Tablets (landscape orientation) and Personal Computers</h1>
        <p className="text-sm opacity-80">
          Please open this site on a larger screen device in landscape orientation.
        </p>
      </div>
    </div>
    </div>
  );
}

export default function App() {
  const isNotPhone = useIsNotPhone();

  if (!isNotPhone) {
    return <NotAvailableScreen />;
  }
  return (
    <div id ="myScrollContainer" className="h-screen overflow-x-hidden overflow-y-scroll snap-y snap-mandatory no-scrollbar">
      <Navbar />
      <main className="snap-container">
        <section id="context" className="snap-start">
          <Contexto />
        </section>
        <section id="land-use" className="snap-start">
          <UsoSuelo />
        </section>
        <section id="carbon-emissions" className="snap-start">
          <EmisionesCarbono/>
        </section>
        <section id="scenarios" className="snap-start">
          <Escenarios />
        </section>
      </main>
    </div>
  );
}